import { getOpportunities } from '@/lib/get-post-opportunities'
import OpportunitiesTable from '@/components/table-archive/OpportunitiesTable'
import { MainColumn, MainColumnLeft, MainColumnRight } from '@/components/main-column/MainColumn'
import { LinkProps } from '@/types/types'

export default async function Opportunities({
  title = 'Latest Opportunities',
  text = '',
  viewAllLink = { title: 'View All', url: '/opportunities/' },
  types,
  sectors,
  lifecycleStages,
  postId,
}: {
  title?: string
  text?: string
  viewAllLink?: LinkProps
  types?: string[]
  sectors?: string[]
  lifecycleStages?: string[]
  postId?: number | string
}): Promise<JSX.Element | null> {
  // Fetch opportunities based on the provided filters
  const opportunities = await getOpportunities({
    types: types,
    sectors: sectors,
    lifecycleStages: lifecycleStages,
    exclude: postId,
    perPage: 10,
  })

  // If no opportunities are found, return null
  if (!opportunities?.length) {
    return null
  }

  return (
    <MainColumn className="mb-xxxl">
      <MainColumnLeft title={title} text={text} button={viewAllLink} />

      <MainColumnRight>
        <OpportunitiesTable
          columns={['Title', 'Type', 'Sector', 'Organisation']}
          opportunities={opportunities}
        />
      </MainColumnRight>
    </MainColumn>
  )
}
